import clsx from 'clsx';
import { Base } from '../Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "Avatar-root_nWGEP"
};
const themesMap = {
  light: {
    backgroundColor: 'anthracite',
    color: 'white',
    weight: 'semibold'
  },
  dark: {
    backgroundColor: 'white',
    color: 'anthracite',
    weight: 'semibold'
  }
};
function getInitial(name, fallback = '?') {
  if (!name || typeof name !== 'string') {
    return fallback;
  }
  return name.replace(/\s+/, '').slice(0, 1);
}
function Avatar({
  username,
  theme = 'light',
  className,
  ...extraProps
}) {
  const themeProps = typeof theme === 'string' && theme in themesMap ? themesMap[theme] : {};
  return /*#__PURE__*/_jsx(Base, {
    "aria-hidden": true,
    tagName: "span",
    flexInline: true,
    flexJustifyCenter: true,
    flexAlignItemsCenter: true,
    flexShrink0: true,
    weight: "semibold",
    transform: "uppercase",
    className: clsx(styles.root, className),
    ...themeProps,
    ...extraProps,
    children: getInitial(username)
  });
}
export { getInitial };
export default Avatar;